import Carousel from 'react-bootstrap/Carousel';
// photos
import water from '../assets/images/glass_of_water.png';
import fish from '../assets/images/fish.png';
// import popcorn from '../assets/images/popcorn.png';

function SliderComponent() {
  const carouselInfo = [
    {
      id: 0,
      slogan: 'HAVE YOU CONSIDERED THAT',
      headline: 'Could be your water contaminated with PFAS chemicals?',
      text: 'PFAS are human-made chemicals and the most common way to consume them is through drinking water or food.',
      image: water,
      imgAltText: 'Drinking water',
    },
    {
      id: 1,
      slogan: 'HAVE YOU CONSIDERED THAT',
      headline: 'Could be your fish contaminated with PFAS chemicals?',
      text: 'PFAS are human-made chemicals and the most common way to consume them is through drinking water or food.',
      image: fish,
      imgAltText: 'Fish',
    },
    // {
    //   id: 2,
    //   slogan: 'HAVE YOU CONSIDERED THAT',
    //   headline: 'Could be your popcorn contaminated with PFAS chemicals?',
    //   text: 'PFAS are human-made chemicals and the most common way to consume them is through drinking water or food.',
    //   image: popcorn,
    //   imgAltText: 'Popcorn',
    // },
  ];

  return (
    <Carousel interval={5500}>
      {carouselInfo.map((x) => {
        return (
          <Carousel.Item key={x.id}>
            <img
              className='d-block w-50'
              src={x.image}
              alt={x.imgAltText}
              id={x.id}
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default SliderComponent;
